/* @ngInject */
function SubtaskItemController ($scope, $attrs, $rootScope, $timeout, $q, $location, $translate, AdminService, UserService, TasksService, ToastService, UdsModalService, ModalStackService, SegmentService, Utils) {
  const getSubtaskDetailsDialogController = () => $q.when(import('../../dialogs/subtask-details/subtask-details-dialog.controller'))
  const getTimesheetRegisterDialogController = () => $q.when(import('../../dialogs/timesheet-register/timesheet-register-dialog.controller'))
  $scope.subtask = $scope.subtask || {}
  $scope.isEditingTitle = false
  $scope.titleHover = false
  $scope.newSubtaskTitle = $scope.subtask.title
  $scope.asigneeOptions = []
  $scope.subtaskAssignee = null
  $scope.timesheetEnabled = false

  $scope.assigneeFlags = {
    top: 10,
    skip: 0,
    hasMoreOptions: true,
    search: ''
  }

  const api = {
    getSubtaskDetailsDialogController,
    getTimesheetRegisterDialogController,
    _getAssigneeOptions,
    _checkTimesheetEnabled,
    _setAssignee,
    _handleAssigneeOptions,
    _setUrlParams,
    _getStatusName
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._setAssignee()
    api._getAssigneeOptions()
    api._checkTimesheetEnabled()
  }

  $scope.titleEditClick = () => {
    $scope.newSubtaskTitle = $scope.subtask.title
    $scope.isEditingTitle = true

    $timeout(() => {
      const input = $attrs.$$element.find('.title-edit-input')[0]
      input.focus()
    }, 100, true)
  }

  $scope.titleSaveClick = () => {
    $scope.isEditingTitle = false
    const { id } = $scope.subtask

    TasksService.editSubtaskTitle(id, $scope.newSubtaskTitle).then(() => {
      $scope.onChange($scope.subtask)
    }).catch(ToastService.defaultErrorToast)
  }

  $scope.openTimesheetRegisterDialog = function () {
    api.getTimesheetRegisterDialogController().then(({ TimesheetRegisterDialogController }) => {
      const timesheetFull = UdsModalService.createModal({
        controller: TimesheetRegisterDialogController,
        modalName: 'timesheetRegisterDialog',
        data: { taskId: $scope.subtask.id, taskName: $scope.subtask.name, boardId: $scope.subtask.column.boardId, isSubtask: true, taskType: $scope.subtask.originType }
      })
      timesheetFull.open()
    })
  }

  $scope.titleCancelClick = () => {
    $scope.isEditingTitle = false
  }

  $scope.titleMouseEnter = (event) => {
    $scope.titleHover = true
  }

  $scope.titleMouseLeave = (event) => {
    $scope.titleHover = false
  }

  $scope.onStatusChange = (status) => {
    const { boardId } = $scope.subtask.column

    TasksService.updateSubtaskStatus($scope.subtask.id, status, boardId).then(() => {
      $scope.onChange($scope.subtask)
      if (status === 'DONE') {
        SegmentService.track('finished-task', { type: 'SUBTASK', task_id: $scope.subtask.id })
      }
    }).catch((err) => {
      if (err.status === 400) {
        const statusName = api._getStatusName(status)
        ToastService.showErrorToast($translate.instant('subtaskStatusWarning', { status: statusName }))
        $scope.onChange($scope.subtask)
        return
      }

      ToastService.defaultErrorToast()
    })
  }

  function _getStatusName (status) {
    const names = {
      INBOX: $translate.instant('inbox'),
      PROGRESS: $translate.instant('inProgress'),
      DONE: $translate.instant('done'),
      DEFAULT: ''
    }

    if (names[status]) return names[status]
    return names.DEFAULT
  }

  $scope.handleAssigneeSelect = (event) => {
    const assignee = event.detail
    $scope.subtaskAssignee = assignee
    TasksService.updateSubtaskAssignee($scope.subtask.id, [assignee.value]).then(() => {
      $scope.onChange($scope.subtask)
    }).catch(ToastService.defaultErrorToast)
  }

  $scope.onAssigneeSearch = (event) => {
    const { search } = event.detail
    $scope.assigneeFlags.skip = 0
    $scope.assigneeFlags.search = search

    api._getAssigneeOptions(true)
  }

  $scope.onInfiniteAssignees = (event) => {
    const totalCount = event.detail?.totalCount
    $scope.assigneeFlags.skip = totalCount

    api._getAssigneeOptions()
  }

  $scope.onAssigneeClick = (event) => {
    const select = event.target

    $timeout(() => {
      if (select.show && $scope.isLast) {
        select.scrollIntoView({ behavior: 'smooth' })
      }
    }, 150, true)
  }

  $scope.openSubtaskModal = () => {
    if ($scope.isEditingTitle) return

    const lastModalOpened = ModalStackService.getLastModalOpened()
    lastModalOpened.closeCallback()

    api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: SubtaskDetailsDialogController,
        modalName: 'subtaskDetailsDialog',
        data: {
          subtask: $scope.subtask
        },
        onClose: () => {
          api._setUrlParams()
        }
      })

      modal.open()
    })
  }

  function _getAssigneeOptions (reset) {
    const { top, skip, search } = $scope.assigneeFlags

    AdminService.getUsers(
      top,
      skip,
      { role: ['DESIGNER', 'ADMINISTRATOR', 'SYSTEM_ADMINISTRATOR'], search }
    ).then((response) => {
      const assignees = response.d.results
      const totalCount = response.d.__count

      $scope.assigneeFlags.skip += $scope.assigneeFlags.top

      const assignessOptions = api._handleAssigneeOptions(assignees)

      if (reset) {
        $scope.asigneeOptions = assignessOptions
        $scope.assigneeFlags.hasMoreOptions = totalCount > assignessOptions.length
        return
      }

      $scope.asigneeOptions = [...$scope.asigneeOptions, ...assignessOptions]
      $scope.assigneeFlags.hasMoreOptions = totalCount > $scope.asigneeOptions.length
    }).catch(ToastService.defaultErrorToast)
  }

  function _checkTimesheetEnabled () {
    $rootScope.getCompanyConfigurations().then(companyConfigurations => {
      const enableTimesheet = Boolean(companyConfigurations?.ENABLE_TIMESHEET)
      const isValidSubtask = !!$scope.subtask.column?.boardId && !$scope.isArchived
      const isValidUser = ($rootScope.isUserSysAdminAdminDesigner() || $rootScope.isGuest())

      $scope.timesheetEnabled = enableTimesheet && isValidSubtask && isValidUser
    })
  }

  function _setAssignee () {
    const assignee = $scope.subtask.assignees[0]

    if (assignee) {
      AdminService.getUserById(assignee.id).then(user => {
        const { id, name } = user

        $scope.subtaskAssignee = { label: name, value: id, avatar: UserService.getUserProfileImage(id) }
      }).catch(ToastService.defaultErrorToast)
    }
  }

  function _handleAssigneeOptions (assignees) {
    const assignessOptions = assignees.map(assignee => {
      return {
        label: assignee.name,
        value: assignee.id,
        avatar: UserService.getUserProfileImage(assignee.id)
      }
    })

    return assignessOptions
  }

  function _setUrlParams (taskId, subtaskId) {
    const url = $location.search()

    const request = {
      request: taskId || null,
      subtask: subtaskId || null
    }
    const searchOptions = Object.assign({}, url, request)

    $location.search(searchOptions)
  }

  $scope.lineBreakTooltipText = (text) => {
    return Utils.lineBreakTooltipText(text)
  }
}

export { SubtaskItemController }
